import { createApiCall } from 'lib/base';

const FETCH_NHSV_WEBHOOK_EVENTS = 'FETCH_NHSV_WEBHOOK_EVENTS';

const apiCall = createApiCall(FETCH_NHSV_WEBHOOK_EVENTS, () => ({
  endpoint: 'api/admin/nhsv/webhook/events',
  method: 'GET',
}));

export default apiCall;
